import { useComplaintDialog } from "./DialogContext";
import { ComplaintModalLayout } from "./ComplaintModalLayout";
import PictureList from "../../../../components/UI/viewDialogs/PictureList";

ComplaintModalLayout.Pictures = function Pictures() {
  const { pictureList, openImageSlider, setImageSliderCurrentIndex } =
    useComplaintDialog();

  if (!pictureList) return null;

  return (
    <PictureList
      pictureList={pictureList}
      openImageSlider={openImageSlider}
      setImageSliderCurrentIndex={setImageSliderCurrentIndex}
    />
  );
};
